// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Website Content — compact table layout */

.wcm-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: calc(100vh - 100px);
  min-height: 480px;
  max-height: calc(100vh - 88px);
}

.wcm-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.wcm-search {
  flex: 1 1;
  min-width: 160px;
  max-width: 280px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
}

.wcm-select {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  background: #fff;
  color: #475569;
  min-width: 140px;
}

.wcm-toolbar-note {
  font-size: 15px;
  color: #94a3b8;
}

.wcm-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.wcm-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.wcm-btn:hover:not(:disabled) {
  background: #f8fafc;
}

.wcm-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.wcm-btn--primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.wcm-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.wcm-btn--danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.wcm-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 15px;
  flex-shrink: 0;
}

.wcm-toast button {
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.wcm-toast--ok {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #bbf7d0;
}

.wcm-toast--err {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.wcm-table-panel {
  flex: 1 1;
  min-height: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wcm-table-scroll {
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.wcm-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
}

.wcm-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafbfc;
  padding: 9px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e2e8f0;
}

.wcm-table thead th:last-child {
  width: 88px;
  text-align: right;
}

.wcm-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: top;
}

.wcm-table tbody tr:hover {
  background: #f8fafc;
}

.wcm-section {
  display: block;
  font-weight: 600;
  color: #0f172a;
  font-family: ui-monospace, monospace;
  font-size: 15px;
}

.wcm-content {
  display: block;
  color: #334155;
  line-height: 1.45;
  word-break: break-word;
}

.wcm-meta {
  display: block;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 4px;
}

.wcm-badge {
  font-size: 14px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  text-transform: uppercase;
}

.wcm-badge--active {
  background: #dcfce7;
  color: #166534;
}

.wcm-badge--inactive {
  background: #f1f5f9;
  color: #64748b;
}

.wcm-actions {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.wcm-icon-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.wcm-table tbody tr:hover .wcm-icon-btn {
  color: #94a3b8;
}

.wcm-icon-btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #475569;
}

.wcm-icon-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
  color: #dc2626;
}

.wcm-empty,
.wcm-loading {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 15px;
  padding: 24px;
}

.wcm-spin {
  animation: wcm-spin 0.8s linear infinite;
}

@keyframes wcm-spin {
  to { transform: rotate(360deg); }
}

/* Modals */
.wcm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  padding: 16px;
}

.wcm-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 520px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
}

.wcm-modal--sm {
  max-width: 400px;
}

.wcm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.wcm-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.wcm-modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wcm-modal-body {
  padding: 16px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.wcm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
}

.wcm-field {
  margin-bottom: 12px;
}

.wcm-field:last-child {
  margin-bottom: 0;
}

.wcm-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
}

.wcm-field input,
.wcm-field textarea,
.wcm-field select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  box-sizing: border-box;
}

.wcm-field textarea {
  min-height: 120px;
  resize: vertical;
}

.wcm-toggle-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #475569;
  margin-top: 4px;
}

.wcm-confirm-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fef2f2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.wcm-confirm-text {
  text-align: center;
  font-size: 15px;
  color: #64748b;
}

@media (max-width: 768px) {
  .wcm-page {
    height: auto;
    max-height: none;
  }

  .wcm-table-scroll {
    max-height: 480px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/website/WebsiteContentManager.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Website Content — compact table layout */\n\n.wcm-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: calc(100vh - 100px);\n  min-height: 480px;\n  max-height: calc(100vh - 88px);\n}\n\n.wcm-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.wcm-search {\n  flex: 1;\n  min-width: 160px;\n  max-width: 280px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n}\n\n.wcm-select {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  background: #fff;\n  color: #475569;\n  min-width: 140px;\n}\n\n.wcm-toolbar-note {\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.wcm-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.wcm-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.wcm-btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.wcm-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.wcm-btn--primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.wcm-btn--primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.wcm-btn--danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.wcm-toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.wcm-toast button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.wcm-toast--ok {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #bbf7d0;\n}\n\n.wcm-toast--err {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.wcm-table-panel {\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.wcm-table-scroll {\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.wcm-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 15px;\n}\n\n.wcm-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fafbfc;\n  padding: 9px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.wcm-table thead th:last-child {\n  width: 88px;\n  text-align: right;\n}\n\n.wcm-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: top;\n}\n\n.wcm-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.wcm-section {\n  display: block;\n  font-weight: 600;\n  color: #0f172a;\n  font-family: ui-monospace, monospace;\n  font-size: 15px;\n}\n\n.wcm-content {\n  display: block;\n  color: #334155;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.wcm-meta {\n  display: block;\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n\n.wcm-badge {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  text-transform: uppercase;\n}\n\n.wcm-badge--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.wcm-badge--inactive {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.wcm-actions {\n  display: flex;\n  gap: 4px;\n  justify-content: flex-end;\n}\n\n.wcm-icon-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: #cbd5e1;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wcm-table tbody tr:hover .wcm-icon-btn {\n  color: #94a3b8;\n}\n\n.wcm-icon-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.wcm-icon-btn--danger:hover:not(:disabled) {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.wcm-empty,\n.wcm-loading {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 24px;\n}\n\n.wcm-spin {\n  animation: wcm-spin 0.8s linear infinite;\n}\n\n@keyframes wcm-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Modals */\n.wcm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  padding: 16px;\n}\n\n.wcm-modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 520px;\n  max-height: calc(100vh - 32px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);\n}\n\n.wcm-modal--sm {\n  max-width: 400px;\n}\n\n.wcm-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.wcm-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.wcm-modal-close {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wcm-modal-body {\n  padding: 16px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.wcm-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.wcm-field {\n  margin-bottom: 12px;\n}\n\n.wcm-field:last-child {\n  margin-bottom: 0;\n}\n\n.wcm-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 5px;\n}\n\n.wcm-field input,\n.wcm-field textarea,\n.wcm-field select {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.wcm-field textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.wcm-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  color: #475569;\n  margin-top: 4px;\n}\n\n.wcm-confirm-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #fef2f2;\n  color: #dc2626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 12px;\n}\n\n.wcm-confirm-text {\n  text-align: center;\n  font-size: 15px;\n  color: #64748b;\n}\n\n@media (max-width: 768px) {\n  .wcm-page {\n    height: auto;\n    max-height: none;\n  }\n\n  .wcm-table-scroll {\n    max-height: 480px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
